import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import { getAssignmentOptions, listMyAllocationsOptions } from "@/client/@tanstack/react-query.gen"
import ReviewSelection from "@/routes/-pages/ReviewSelection"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/assessment/$assessmentId/review/")({
  loader: ({ params }) => {
    const { assessmentId } = params
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getAssignmentOptions({ path: { assignment_id: assessmentId } })),
        queryClient.prefetchQuery(listMyAllocationsOptions({ path: { assignment_id: assessmentId } })),
      ]),
    )
  },
  component: ReviewSelection,
})
